import {DateStringNullable, NullableKeys, todayDate} from '@fl/cmsch-fe-library';

/** Form name used for subject membership edits. */
export const userMemberSubjectFormName = 'userMemberSubject';

/** Values submitted by the user membership form. */
export interface UserMemberSubjectForm {
    /** Owning user profile id. */
    userProfileId: number;
    /** Existing membership id when editing. */
    subjectMemberId: number | null;
    /** Selected subject id. */
    subjectId: number;
    /** Approval start date. */
    approvedFrom: DateStringNullable;
    /** Approval end date. */
    approvedTo: DateStringNullable;
}

/**
 * Empty form values used before the membership form is initialized.
 *
 * @param userProfileId User profile that owns the membership row.
 * @returns Default membership form values for a new row.
 *
 * @example
 * userMemberSubjectInitialValues(42);
 */
export const userMemberSubjectInitialValues = (userProfileId: number): NullableKeys<UserMemberSubjectForm> => ({
    subjectMemberId: null,
    subjectId: null,
    approvedFrom: todayDate(),
    approvedTo: null,
    userProfileId,
});
